<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.domains', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>{{ $t('messages.information') }}</div>
                    <div class="flex gap-x-1 items-center">
                        <IconBrandYoutube class="text-red-500" />
                        <a
                            target="_blank"
                            class="text-indigo-500"
                            href="https://www.youtube.com/watch?v=OSQtK_Pb63c&list=PLZZYS-CAqB3cEbkwh9EM6ejT9xsIoiqKK&index=2"
                        >
                            {{ $tc('messages.tutorials', 1) }}
                        </a>
                    </div>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.stages', 1)" for="stage_id" />
                            <FormSelect
                                id="stage_id"
                                required
                                v-model="form.stage_id"
                                :options="options.stages"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.stage_id" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="`${$t('messages.name')} (${$t('locales.es')})`" for="name" />
                            <FormInput
                                required
                                id="form.translations.es.name"
                                v-model="form.translations.es.name"
                                name="name"
                                type="text"
                                max="191"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="`${$t('messages.name')} (${$t('locales.ca')})`" for="name" />
                            <FormInput
                                id="form.translations.ca.name"
                                v-model="form.translations.ca.name"
                                name="name"
                                type="text"
                                max="191"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="`${$t('messages.name')} (${$t('locales.en')})`" for="name" />
                            <FormInput
                                id="form.translations.en.name"
                                v-model="form.translations.en.name"
                                name="name"
                                type="text"
                                max="191"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import { IconBrandYoutube } from '@tabler/icons-vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
        IconBrandYoutube,
    },
    layout: AdminLayout,
    name: 'Create',
    props: ['meta', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                stage_id: '',
                translations: {
                    en: { name: '' },
                    es: { name: '' },
                    ca: { name: '' },
                },
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
